<template>
    <div class="layoutMain">
        <div class="banner">
            <img :src="imageBanner" alt="" class="banner">
        </div>
        <div class="w1100">
            <div class="crumbs">
                <span>首页</span>
                <span>>></span>
                <span>{{title}}</span>
                <span v-if="isSubtext"> >></span>
                <span v-if="isSubtext">详情</span>
            </div>
            <div class="subTitle" v-if="isTrue">
              {{title}}
            </div>
            <slot name="content"></slot>
        </div>
  </div>
</template>
<script>
export default {
    props:{
        banner: {
            type:String,
            default:''
        },
        subtitle: {
            type:String,
            default:''
        },
        isTrue: {
            type:Boolean,
            default: true
        },
        isSubtext: {
            type:Boolean,
            default: false
        }
    },
    data () {
        return {
            imageBanner: '',
            title: ''
        }
    },
    created(){
        this.$nextTick(()=>{
            this.imageBanner = this.banner
            this.title = this.subtitle
        })
    }
}
</script>
<style lang="scss" scoped>
.layoutMain {
    margin-bottom: 60px;
    .banner{width: 100%;}
    .w1100{
        padding: 0 10px;
        box-sizing: border-box;
    }
    .w1100 .subTitle{
        margin-top: 30px;
        font-size: 30px;
        color: #333;
        font-weight: normal;
    }
    .w1100 .text{
        text-indent: 2em;
        font-size: 17px;
        color: #333;
        text-align: left;
    }
   
    /* 在屏幕宽度小于等于600像素时应用以下样式 */
    @media screen and (max-width: 1100px) {
        .w1100{
            width: 100% ;
        }
        .w1100 .news-title{
            margin: 0;
        }
        .w1100>.text{
            text-indent: 0em;
            font-size: 17px;
            color: #333;
            text-align: left;
            margin: 10px 0;
        }
        .weight{
            line-height: 1.5 !important;
        }
        
    }
}   
</style>
